import axios from "axios";
import ConstantList from "../appConfig";

const API_PATH = ConstantList.API_EN_POINT + "/patient-service-register-history";

export const pagingRegisterServiceHistory = (searchObject) =>
  axios.post(API_PATH + "/search-by-page", searchObject);
